import { fabClasses } from "@mui/material";
import { atom } from "recoil";
import { IVendorInfo, SelectedRowsToDelete } from "../types";

export const vendorSearchFilter = atom({
  key: "vendorSearchFilter",
  default: {
    vendorId: "",
    vendorName: "",
    vendorTypeName: "",
    vendorTypeId: null,
    phone: "",
    physicalStreet: "",
    physicalState: "",
    inactiveAccount: null,
  },
});
export const vendorTableData = atom({
  key: "vendorTableData",
  default: [],
});
export const addStateVendor = atom({
  key: "addStateVendor",
  default: false,
});
export const editStateVendor = atom({
  key: "editStateVendor",
  default: false,
});
export const rowEditIdStateVendor = atom({
  key: "rowEditIdStateVendor",
  default: [],
});
export const disableButtonStateVendor = atom({
  key: "disableButtonStateVendor",
  default: false,
});

export const selectedRowsStateVendor = atom({
  key: "selectedRowsStateVendor",
  default: [],
});

export const setFilterTextVendor = atom({
  key: "setFilterTextVendor",
  default: "",
});

export const vendorFromVendorHome = atom({
  key: "vendorFromVendorHome",
  default: false,
});

export const vendorShowState = atom({
  key: "vendorShowState",
  default: false,
});

export const vendorViewData = atom<any>({
  key: "vendorViewData",
  default: undefined,
});
export const mainVendorSelectedTab = atom({
  key: "mainVendorSelectedTab",
  default: 0,
});

export const vendorFromSecurity = atom({
  key: "vendorFromSecurity",
  default: false,
});

export const vendorServiceId = atom<IVendorInfo | undefined>({
  key: "vendorServiceId",
  default: undefined,
});

export const selectedRowsStateOVS = atom<SelectedRowsToDelete | undefined>({
  key: "selectedRowsStateOVS",
  default: undefined,
});

export const closeFromVendor = atom({
  key: "closeFromVendor",
  default: true,
});

export const onCloseFromOffice = atom({
  key: "onCloseFromOffice",
  default: false,
});

export const ovsFromVendor = atom({
  key: "ovsFromVendor",
  default: false,
});

export const entityEIN = atom({
  key: "entityEIN",
  default: undefined,
});

export const filtered = atom({
  key: "filtered",
  default: "",
});

export const vendorViewId = atom({
  key: "vendorViewId",
  default: 0,
});

export const pciFileAttachment = atom<(File | null)[]>({
  key: "pciFileAttachment",
  default: [null],
});

export const pciFileAttachmentForDelete = atom({
  key: "pciFileAttachmentForDelete",
  default: [],
});

export const soc2FileAttachment = atom<(File | null)[]>({
  key: "soc2FileAttachment",
  default: [null],
});

export const soc2FileAttachmentForDelete = atom({
  key: "soc2FileAttachmentForDelete",
  default: [],
});

export const sqFileAttachment = atom<(File | null)[]>({
  key: "sqFileAttachment",
  default: [null],
});

export const sqFileAttachmentForDelete = atom({
  key: "sqFileAttachmentForDelete",
  default: [],
});

export const miscFileAttachment = atom<(File | null)[]>({
  key: "miscFileAttachment",
  default: [null],
});

export const miscFileAttachmentForDelete = atom({
  key: "miscFileAttachmentForDelete",
  default: [],
});

export const complianceStatus = atom({
  key: "complianceStatus",
  default: "",
});

export const secDisplay = atom({
  key: "secDisplay",
  default: [],
});

export const pciDisplay = atom({
  key: "pciDisplay",
  default: [],
});

export const socDisplay = atom({
  key: "socDisplay",
  default: [],
});

export const miscDisplay = atom({
  key: "miscDisplay",
  default: [],
});
